import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BaseConfig } from '@client';

@Component({
  selector: 'app-container',
  standalone: true,
  template: `
    <section class="base-container" [attr.data-theme]="theme()">
      <ng-content />
    </section>
  `,
  styleUrls: ['./container.component.scss'],
  imports: [CommonModule],
})
export class Container extends BaseConfig {}
